<template>
  <el-table v-loading="loading" :data="dataList" :height="height">
    <el-table-column v-if="!Boolean(contractId)" label="合同名称" min-width="150" align="center">
      <template slot-scope="scope">
        <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContractDetail(scope.row)">{{scope.row.contractName}}</el-link>
      </template>
    </el-table-column>
    <el-table-column label="计划期次" min-width="90" align="center">
      <template slot-scope="scope">
        <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{scope.row.planFundBatch}}</el-link>
      </template>
    </el-table-column>
    <el-table-column label="计划回款(元)" min-width="130" align="center">
      <template slot-scope="scope">
        <span>{{ amountFormat(scope.row.planFundAmount) }}</span>
      </template>
    </el-table-column>
    <el-table-column label="回款状态" min-width="100" align="center" prop="planFundStatusDesc" />
    <el-table-column label="计划回款日期" min-width="110" align="center" prop="planFundDate" />
    <el-table-column label="实际回款(元)" min-width="130" align="center">
      <template slot-scope="scope">
        <span>{{ amountFormat(scope.row.actualAmount) }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>

import {listContractPlanFund} from "@/api/crm/planFund";
import { amountFormat } from '@/utils/index'

export default {
  name: "PlanFundList",
  props: {
    customerId: {},
    contractId: {},
    height: {
      type: String,
      default () {
        return "250"
      }
    }
  },
  data() {
    return {
      loading: false,
      dataList: [],
      amountFormat
    };
  },
  created() {
    if (this.customerId || this.contractId) {
      this.queryList();
    }
  },
  components: {
  },
  watch: {
    customerId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    },
    contractId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    }
  },
  methods: {
    queryList () {
      this.loading = true;
      listContractPlanFund(
        {
        customerId: this.customerId,
        contractId: this.contractId
      }
      ).then(response => {
          this.dataList = response.rows || [];
          this.$emit('after-query', this.dataList);
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    /** 详细按钮操作 */
    toContractDetail(row) {
      this.$router.push("/crm/contract/detail/" + row.contractId);
    },
    /** 详细按钮操作 */
    toDetail(row) {
      this.$router.push("/crm/plan-fund/detail/" + row.id);
    },
  }
};
</script>
